import React from 'react';
import './search-result-item-style.scss';

import Typography from '@src/componentsNew/Typography/Typography';
import SearchIcon from '@src/componentsNew/Icons/Icons/SearchIcon';
import AccessTimeFilledIcon from '@src/componentsNew/Icons/Icons/AccessTimeFilledIcon';

interface SearchResultItemProps {
  imageUrl?: string;
  iconType?: 'time' | 'search';
  title: string;
  searchQuery: string;
  type?: string;
  onClick?: () => void;
}

const SearchResultItem = ({ imageUrl, iconType, title, searchQuery, type, onClick }: SearchResultItemProps) => {
  const renderImage = () => {
    if (imageUrl) {
      return <img className="search-result-item-image" src={imageUrl} alt={title} />;
    } else if (iconType) {
      return (
        <>
          {iconType === 'time' && <AccessTimeFilledIcon />}
          {iconType === 'search' && <SearchIcon />}
        </>
      );
    }
  };

  const renderTitle = () => {
    if (!searchQuery || searchQuery.trim() === '') {
      return (
        <Typography variant="body2" component="span" style={{ color: '#090A0FDE' }}>
          {title}
        </Typography>
      );
    }

    const regex = new RegExp(`(${searchQuery})`, 'gi');
    const parts = title.split(regex);

    return (
      <Typography cName="search-result-item-title" variant="body2" component="div" style={{ color: '#090A0FDE' }}>
        {parts.map((part, i) =>
          regex.test(part) ? (
            <Typography
              key={i}
              cName="search-result-highlight"
              variant="body2"
              component="span"
              style={{ color: '#f82296' }}
            >
              {part}
            </Typography>
          ) : (
            <Typography key={i} variant="body2" component="span" style={{ color: '#090A0FDE' }}>
              {part}
            </Typography>
          ),
        )}
      </Typography>
    );
  };

  return (
    <li className="search-result-item" onClick={onClick}>
      {renderImage()}

      <div className="search-result-item-text-content">
        {renderTitle()}

        {type && (
          <Typography cName="search-result-item-type" variant="caption" component="span" style={{ color: '#11141D61' }}>
            {type}
          </Typography>
        )}
      </div>
    </li>
  );
};

export default SearchResultItem;
